import { NavigationItemFlatTreeConfig } from '@/app/platform/platform-shared/navigation-item-tree/types';
import { NavigationItemNode } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-dragger';
import { NavigationItemData } from '@/app/platform/platform-shared/models/navigation-item.data';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';

export const navigationItemFlatTreeConfig: NavigationItemFlatTreeConfig = {
  getLevel: (node: NavigationItemNode<NavigationItemData>) => node.level,
  isExpandable: (node: NavigationItemNode<NavigationItemData>) => node.expandable,
  getChildren: (node: NavigationItemEntity) => node.children,
  hasChild: (_: number, node: NavigationItemNode<NavigationItemData>) => node.expandable,
  hasNoContent: (_: number, node: NavigationItemNode<NavigationItemData>) => node.name === '',

  transformer: (node: NavigationItemData, level: number) => {
    const flatNode = new NavigationItemNode(node.name, node.id, node);
    flatNode.level = level;
    flatNode.order = node.order;
    flatNode.expandable = node.hasChildren;
    return flatNode;
  }
};
